import React, { useState, useEffect } from "react";

import { PlatformIcon } from "@dialogueconsulting/sked-ui";
import youtubeIconUtils from "../../../../utils/youtube-icon-utils";

const LINKED_PLATFORM = "LINKED";
const linkedPlatformObj = { NAME: LINKED_PLATFORM, TYPE: LINKED_PLATFORM };

const PlatformTabs = ({ platforms, onChange }) => {
  const [activePlatform, setActivePlatform] = useState(null);

  useEffect(() => {
    const platformObjs = platforms;
    let defaultPlatform = LINKED_PLATFORM;
    if (platformObjs.length === 1) {
      defaultPlatform = platformObjs[0].TYPE;
    }

    setActivePlatform(defaultPlatform);
    if (onChange) {
      onChange(defaultPlatform);
    }
  }, [platforms]);

  const handleChange = (type) => {
    setActivePlatform(type);
    if (onChange) {
      onChange(type);
    }
  };

  return (
    <ul
      className="m-0 flex w-[48px] flex-col gap-1 bg-[#f4f4f6] p-1"
      role="tablist"
      aria-orientation="vertical"
      aria-label="Post content platform"
    >
      {Object.keys(platforms).length > 1 && (
        <PlatformTab
          platform={linkedPlatformObj}
          active={activePlatform === LINKED_PLATFORM}
          onChange={handleChange}
        />
      )}
      {platforms.map((platform) => (
        <PlatformTab
          key={platform.NAME}
          platform={platform}
          active={activePlatform === platform.TYPE}
          onChange={handleChange}
        />
      ))}
    </ul>
  );
};

const PlatformTab = ({ platform, active, onChange }) => {
  const activeClasses =
    "bg-white p-[10px] shadow-[0_1px_2px_rgba(16,24,40,0.05)]";
  const inactiveClasses = "bg-transparent p-0";
  const type = youtubeIconUtils.resolveYtRedIcon(platform.NAME);
  const label =
    platform.NAME === LINKED_PLATFORM
      ? "Shared post content"
      : `${platform.NAME} post content`;
  const handleKeyDown = (event) => {
    const tabs = Array.from(
      event.currentTarget
        .closest('[role="tablist"]')
        ?.querySelectorAll('[role="tab"]') || []
    );
    const currentIndex = tabs.indexOf(event.currentTarget);
    let nextIndex;

    switch (event.key) {
      case "ArrowDown":
      case "ArrowRight": {
        nextIndex = (currentIndex + 1) % tabs.length;
        break;
      }
      case "ArrowUp":
      case "ArrowLeft": {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        break;
      }
      case "Home": {
        nextIndex = 0;
        break;
      }
      case "End": {
        nextIndex = tabs.length - 1;
        break;
      }
      default: {
        return;
      }
    }

    event.preventDefault();
    tabs[nextIndex]?.focus();
    tabs[nextIndex]?.click();
  };

  return (
    <li role="presentation" className="m-0 h-[40px] w-[40px] p-0">
      <button
        type="button"
        role="tab"
        aria-label={label}
        aria-selected={active}
        tabIndex={active ? 0 : -1}
        className={`flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-[5px] border-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
          active ? activeClasses : inactiveClasses
        }`}
        onClick={() => onChange(platform.TYPE)}
        onKeyDown={handleKeyDown}
      >
        {platform.NAME === LINKED_PLATFORM && (
          <span className="inline-flex size-5 items-center justify-center">
            <i
              className="fa-solid fa-globe text-[16px] leading-5 text-blue-500"
              aria-hidden="true"
            />
          </span>
        )}
        {platform.NAME !== LINKED_PLATFORM && (
          <span className="inline-flex size-5 items-center justify-center">
            <PlatformIcon
              platform={type}
              youtubeRedPlay={type === "youtubeRedPlay"}
            />
          </span>
        )}
      </button>
    </li>
  );
};

export default PlatformTabs;
